module.exports = __webpack_public_path__ + "img/img_size_01.05504491.png";